module.exports = __webpack_public_path__ + "static/media/Internship.a600b007.svg";